import React, { useState, useEffect } from 'react'

// bootstrap
import {
    Container,
    Image,
    Button,
    Spinner,
} from 'react-bootstrap'

// auth styles
import '../styles/auth-styles.scss'

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// react router
import { Link } from 'react-router-dom';

// logo
// import appLogo from 'assets/images/logo.png'
import appLogo from 'assets/images/logo-on-top.svg'

// redux
import { connect } from 'react-redux'

// react toastify
import { toast } from 'react-toastify';

// API
import { sendResetPassword } from 'utlis/Apis/Customers_API'

// app mesages
import { ERROR_WHILE__NAME, UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages'

// login check
import WithLoginCheck from 'routes/WithLoginCheck'

function ForgotPassword(props) {
    // props
    const { } = props

    // states
    const [buttonDisable, setButtonDisable] = useState(false)
    const [buttonLoading, setButtonLoading] = useState(false)

    // initial forgot password form values
    const initialFormValues = {
        email: "",
    }

    // handle forgot password form validations
    const FormValidationSchema = Yup.object({
        email: Yup.string().email('Invalid email address').required('This field is required'),
    })

    // handle forgot password form submmision
    const onForgotPasswordFormSubmit = values => {
        if (values) {
            // disbling the forgot password button and enabling loading
            setButtonLoading(true)
            setButtonDisable(true)

            // sending password
            sendResetPassword(values.email).then(res => {
                // btn loading
                setButtonLoading(false)
                setButtonDisable(false)

                const resData = res.data

                // if error
                if (resData?.error) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error("Email not found", {
                        autoClose: 2500
                    });
                } else {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the message
                    toast.success("Success", {
                        autoClose: 2500,
                        onClose: () => {
                            // btn loading
                            setButtonLoading(false)
                            setButtonDisable(false)
                        },
                    });
                }

            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} sendResetPassword `, err.message);

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // btn loading
                        setButtonLoading(false)
                        setButtonDisable(false)
                    },
                });
            })
        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialFormValues,
        onSubmit: onForgotPasswordFormSubmit,
        validationSchema: FormValidationSchema
    })

    return (
        <div className="app-wrapper page-login">
            <div className="st-auth overflow-auto">
                <Container fluid className="h-100">
                    <div className="st-auth h-100 d-flex flex-column justify-content-center align-items-center">
                        <div className="inner border st-default-rounded-block bg-white">
                            {/* top sec */}
                            <div className="top-sec">
                                <Link to="/forgot-password" className="d-block mx-auto mb-3 mb-lg-4" style={{ width: 140 }}>
                                    <Image src={appLogo} fluid />
                                </Link>
                                <p className="head st-fs-24 st-fw-700 text-center">Forgot password</p>
                                <p className="mt-1 subhead text-center">Enter your email address</p>
                            </div>

                            {/* LOGIN FORM */}
                            <div className="form-sec">
                                <form
                                    onSubmit={formik.handleSubmit}
                                    noValidate
                                    autoComplete="off">
                                    {/* form field */}
                                    <div className={`
                                        st-form position-relative 
                                        ${(formik.touched.email && formik.errors.email) && "has-msg msg-error"}
                                    `}>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Email"
                                            id="email"
                                            name="email"
                                            {...formik.getFieldProps('email')} />
                                        {
                                            /* form message */
                                            (formik.touched.email && formik.errors.email) && (
                                                <div className="st-form-msg position-absolute">
                                                    <p className="st-fs-12">{formik.errors.email}</p>
                                                </div>
                                            )
                                        }
                                    </div>

                                    {/* buttons */}
                                    <div className="btns d-flex align-items-center pt-1">
                                        <Button
                                            type="submit"
                                            className="st-btn st-btn-primary st-fw-600 text-uppercase d-flex align-items-center justify-content-center w-100"
                                            disabled={buttonDisable}>
                                            {
                                                buttonLoading ? (
                                                    <Spinner animation="border" size="sm" />
                                                ) : (
                                                    <span>Reset Password</span>
                                                )
                                            }
                                        </Button>
                                    </div>
                                </form>
                            </div>
                        </div>

                        {/* other details */}
                        <div className="other-details text-center my-3">
                            <p className="text-decoration-none mb-1">
                                I already have an account. Please <Link to="/login" className="st-text-primary">take me to the login page.</Link>
                            </p>
                            {/* <p className="text-decoration-none">
                                Don't have an account? <Link to="/forgot-password" className="st-text-primary">Sign up.</Link>
                            </p> */}
                        </div>
                    </div>
                </Container>
            </div>
        </div>
    )
}

const getDataFromStore = state => {
    return {
    };
}

export default WithLoginCheck(connect(getDataFromStore, null)(ForgotPassword))